import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    pageData: [],
    masterPageData: [],
    cachedPages: [],
    pageNumber: 0,
    filterName: 'All',
    searchString: '',
    apiType: 'prod'
}

const pageDataSlice = createSlice({
    name: 'pageData',
    initialState,
    reducers: {
        setPageData: (state,action) => {
            state.pageData = action.payload
        },
        setMasterPageData: (state,action) => {
            state.masterPageData = action.payload
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload
        },
        setFilterName: (state, action) => {
            state.filterName = action.payload
        },
        setSearchString: (state, action) => {
            state.searchString = action.payload
        },
        setApiType: (state, action) => {
            state.apiType = action.payload
        },
        setCachedPages: (state, action) => {
            state.cachedPages = action.payload
        }
    }
})

export const { setPageData, setMasterPageData, setFilterName, setPageNumber, setSearchString, setApiType, setCachedPages } = pageDataSlice.actions
export default pageDataSlice.reducer